export const CATEGORIES_FETCH_ERROR = 'Ошибка при получении категорий:';
